import React, {
  ChangeEventHandler,
  MouseEventHandler,
  useEffect,
  useState,
} from "react";
import Navbar from "../../components/Navbar";
import {
  ChatMessageDetailsType,
  ChatMessageType,
} from "../../interfaces/chats";
import { useAppSelector } from "../../store/store";
import "../../css/jobs.css";
import {
  useChangeJobStatusMutation,
  useCheckJobStatusIsAppliedMutation,
  useGetCandidateTestPassedMutation,
  useGetCompanyJobDetailsMutation,
  useGetCustomQuestionsMutation,
  useGetMatchedJobPercentageMutation,
} from "../../store/jobsSlice";
import { useGetCompanyDetailsMutation } from "../../store/commonSlice";
import JobSummaryMap from "../../components/jobs/jobSummaryMap";
import AboutJob from "../../components/jobs/aboutJob";
import JobCompany from "../../components/jobs/jobCompany";
import { useLocation } from "react-router-dom";
import JobQuestionsModal from "../../components/jobs/jobQuestionsModal";
import JobValidateModal from "../../components/jobs/jobValidateModal";
import Loader from "../../components/Loader";

interface JobDescriptionProps {}

function JobDescription(props: JobDescriptionProps) {
  const { user, profileData } = useAppSelector((state) => state["user"]);
  const [matchedJobs, setMatchedJobs] = useState<Array<any>>([]);
  const [companyDetails, setCompanyDetails] = useState<any>([]);
  const [companyJobDetails, setCompanyJobDetails] = useState<any>([]);
  const [matchedJobPercentage, setMatchedJobPercentage] = useState<number>(0);
  const [jobQuestionsModal, setJobQuestionsModal] = useState<boolean>(false);
  const [jobValidateModal, setJobValidateModal] = useState<boolean>(false);
  const [applicationStatus, setApplicationStatus] = useState<string>("");
  const [isAppliedForJob, setAppliedForJob] = useState<boolean>(false);
  const [testFailedModal, setTestFailedModal] = useState<boolean>(false);
  const [isApplyBtnClicked, setApplyBtnClicked] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [jobQuestions, setJobQuestions] = useState<any>([]);
  const [getCompanyDetails] = useGetCompanyDetailsMutation();
  const [getCompanyJobDetails] = useGetCompanyJobDetailsMutation();
  const [getCandidateTestPassed] = useGetCandidateTestPassedMutation();
  const [getCustomQuestions] = useGetCustomQuestionsMutation();
  const [checkJobStatusIsApplied] = useCheckJobStatusIsAppliedMutation();
  const [changeJobStatus] = useChangeJobStatusMutation();
  const location = useLocation();

  useEffect(() => {
    getCompanyDetailsFromDB();
    getCompanyJobDetailsFromDB();
    checkIfJobAlreadyApplied();
  }, []);

  const getCompanyDetailsFromDB = async () => {
    const payload = {
      param: location.state.companyId,
    };

    getCompanyDetails(payload)
      .unwrap()
      .then((incomingData: any) => {
        console.log({ incomingCompanyDetails: incomingData });
        setCompanyDetails(incomingData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getCompanyJobDetailsFromDB = async () => {
    const payload = {
      param: location.state.companyJobId,
    };

    getCompanyJobDetails(payload)
      .unwrap()
      .then((incomingData: any) => {
        console.log({ incomingCompanyJobDetails: incomingData });
        setCompanyJobDetails(incomingData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onBtnClickForApplyJob = () => {
    if (location.state.jobMatchPercentage >= 50) {
      setApplyBtnClicked(true)
      getCandidateTestStatus();
    } else {
      setJobValidateModal(true);
    }
  };

  const checkIfJobAlreadyApplied = async () => {
    const filterObj = encodeURIComponent(`{
        "where": {
        "companyJobId": "${location.state.companyJobId}"
        }
}`);

    const payload = {
      userId: user?.id,
      filterObj,
    };

    checkJobStatusIsApplied(payload)
      .unwrap()
      .then((jobStatus: any) => {
        setApplicationStatus(jobStatus[0]?.applicationStatus ?? "");
        setApplyBtnClicked(false)
      }).catch(()=>{
        setApplyBtnClicked(false)
      })
  };

  const getCandidateTestStatus = async () => {
    const payload = {
      userId: user?.id,
      jobId: companyJobDetails?.companyJob?.id,
    };

    getCandidateTestPassed(payload)
      .unwrap()
      .then((testPassed: any) => {
        if (!testPassed) {
          setTestFailedModal(true)
          setApplyBtnClicked(false)
        } else {
          getCandidateCustomQuestions();
        }
      });
  };

  const getCandidateCustomQuestions = () => {
    const payload = {
      jobId: companyJobDetails?.companyJob?.id,
    };

    getCustomQuestions(payload)
      .unwrap()
      .then((data: any) => {
        if (data?.length > 0) {
          setApplyBtnClicked(false)
          setJobQuestionsModal(true);
          setJobQuestions(data);
        } else {
          changeJobStatusToApplied();
        }
      });
  };

  const changeJobStatusToApplied = async () => {
    const payload = {
      userId: user?.id,
      companyJobId: companyJobDetails?.companyJob?.id,
      applicationStatus: "Awaiting",
    };

    changeJobStatus(payload)
      .unwrap()
      .then((data: any) => {
        checkIfJobAlreadyApplied();
      });
  };

  return (
    <div>
      <Navbar />
      {isLoading ? (
        <Loader loader={isLoading} />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              backgroundColor: "#f4f5f7",
              height: "100vh",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
              }}
            >
              <JobCompany
                onApplyJob={onBtnClickForApplyJob}
                companyData={companyDetails}
                companyJobData={companyJobDetails}
                applicationStatus={applicationStatus}
                isApplyBtnClicked={isApplyBtnClicked}
              />
            </div>
            <div className="summary-area__summary">
              <AboutJob
                companyData={companyDetails}
                companyJobData={companyJobDetails}
              />
              <div className="summary-area__map">
                <h3>We are looking for</h3>
                <div className="map__map-container">
                  <JobSummaryMap data={companyJobDetails} />
                </div>
              </div>
            </div>
          </div>
          {jobQuestionsModal && (
            <JobQuestionsModal
              jobQuestions={jobQuestions}
              jobId={companyJobDetails?.companyJob?.id}
              isApplied={isAppliedForJob}
              setApplied={() => setAppliedForJob(true)}
              onCloseModal={() => setJobQuestionsModal(false)}
              updateJobStatus={checkIfJobAlreadyApplied}
            />
          )}

          {testFailedModal  && (
            <JobValidateModal headerText={"You can't apply for this job right now"} contentText={"You didn't meet the required standards in the skills test, so you're not eligible for the job at the moment. Feel free to retake the test in 90 days."} onCloseModal={() => setTestFailedModal(false)} />
          )}
          { jobValidateModal && (
            <JobValidateModal headerText={"You can't apply for this job right now"} contentText={'Please note that only candidates meeting a minimum matching criteria of 50 or higher are eligible to apply for jobs through our portal'} onCloseModal={() => setJobValidateModal(false)} />
          )}
        </>
      )}
    </div>
  );
}

export default JobDescription;
